import React from 'react';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { Cell, HtmlTable } from '../../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../../../../../../CommonComponents/OPL/Shimmer/Shimmer';

export const AkoyaAccountsLoading = () => {
  return (
    <HtmlTable variant="embedded">
      <table>
        <colgroup>
          <col width="70%" />
          <col width="30%" />
        </colgroup>

        <thead>
          <tr>
            <th colSpan={2}>
              <Text variant="smallCaps" textAlign="left" px="8">
                Name
              </Text>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <Cell isFlex>
              <Shimmer width="100%" height={56} />
            </Cell>

            <td>
              <Box display="flex" justifyContent="space-between">
                <Shimmer width="auto" height={56} />

                <Shimmer width="auto" height={56} />
              </Box>
            </td>
          </tr>
        </tbody>
      </table>
    </HtmlTable>
  );
};
